import { store } from '@store' //eslint-disable-line
import { initAxios } from '@technologyadvice/relay-frontend/src/util/axios'

export default initAxios(store, '/accounts/bff')
